import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ChangeDetectorRef, Component, Injector, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { take } from "rxjs/operators";
import {
  SharedModule,
  FormInputComponent,
  ModalService,
  DataService,
  InputComponentConfig,
  StringCustomFieldConfig,
} from "@bb-vendure/admin-ui/core";
import SelectZoneModalComponent from "../select-zone-modal/select.component";
import { GetAllCountriesDocument } from "src/generated-gql/graphql";

type InputListItem = {
  id: number;
  code: string;
  // componentRef?: ComponentRef<FormInputComponent>;
  // control: UntypedFormControl;
};

@Component({
  imports: [SharedModule],
  standalone: true,
  templateUrl: "./country-shipping-method-list.component.html",
  styleUrl: "./country-shipping-method-list.component.scss",
})
export class CountryListComponent
  implements OnInit, FormInputComponent<StringCustomFieldConfig>
{
  listItems: {
    id: string;
    code: string;
    name: string;
  }[] = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private injector: Injector,
    private modalService: ModalService,
    private dataService: DataService
  ) {}
  config: StringCustomFieldConfig;

  ngOnInit(): void {
    console.log(this.formControl);

    if (this.formControl.value) {
      const countryCodes = this.formControl.value.split(",");
      this.dataService
        .query(GetAllCountriesDocument, {
          options: {
            filter: {
              code: {
                in: countryCodes,
              },
            },
          },
        })
        .single$.pipe(take(1))
        .subscribe((res) => {
          for (const c of res.countries.items) {
            this.listItems.push({
              id: c.id,
              code: c.code,
              name: c.name,
            });
          }

          this.changeDetectorRef.markForCheck();
        });
    } else {
      this.formControl.patchValue("");
    }
  }
  isListInput?: boolean | undefined = false;
  readonly: boolean;
  formControl: FormControl<string>;

  trackById(index: number, item: { id: number }) {
    return item.id;
  }

  moveListItem(event: CdkDragDrop<InputListItem>) {
    if (this.listItems) {
      moveItemInArray(this.listItems, event.previousIndex, event.currentIndex);
    }
  }

  removeListItem(item: InputListItem) {
    if (this.listItems) {
      this.listItems = this.listItems.filter((i) => i.code !== item.code);

      this.formControl.patchValue(this.listItems.map((i) => i.code).join(","));
      this.formControl.markAsDirty();
    }
  }

  addListItem() {
    if (!this.listItems) {
      this.listItems = [];
    }

    this.modalService
      .fromComponent(SelectZoneModalComponent, {
        size: "lg",
        closable: true,
      })
      .pipe(take(1))
      .subscribe((z) => {
        if (z) {
          const countries = z.members;

          for (const c of countries) {
            if (!this.listItems.find((i) => i.id === c.id)) {
              const data = c;
              this.listItems.push(data);
            }
          }

          this.formControl.patchValue(
            this.listItems.map((i) => i.code).join(",")
          );

          this.formControl.markAsDirty();
        }
      });

    // this.listItems.push({
    //   id: this.listId++,
    // });
    //this.renderList$.next();
  }
}
